import React from 'react';

import Logo from '../logo';
import NoData from '../noData';
import Animate from '../animate';

import './index.scss';

const ErrorView = () => {
    return (
        <>
            <div className='error-view-holder'>
                <NoData
                    icon={{
                        name: 'bug',
                    }}
                    title="Something's gone wrong"
                    subTitle={(
                        <>
                            We're looking into why this has happened.<br/>
                            If this continues email <a className="link-effect" href="mailto:hello@pindropapp.com">hello@pindropapp.com</a>.
                        </>
                    )}
                    primaryCTA={{
                        children: 'Refresh',
                        onClick: () => window.location.reload(),
                    }}
                />
            </div>
            <Animate
                fit
                animation='fadeIn'
            >
                <Logo fixed />
            </Animate>
        </>
    );
};

export default ErrorView;
